import { createSelector } from 'reselect'

const qsSelector = state => state.qs

export default createSelector(
	[qsSelector],
	qs => ({
		presentationOrigin: qs.presentationOrigin || '',
		presentationId: qs.presentationId || '',
	})
)
